import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import { motion } from "framer-motion";

const CLUBS = [
  {
    id: "90s Kids",
    name: "90s Kids",
    emoji: "📼",
    description: "SRK romances & iconic soundtracks",
    color: "from-purple-500/20 to-pink-500/20",
    borderColor: "border-purple-500/30",
  },
  {
    id: "New Era",
    name: "New Era",
    emoji: "🚀",
    description: "Modern masterpieces & fresh voices",
    color: "from-blue-500/20 to-cyan-500/20",
    borderColor: "border-blue-500/30",
  },
  {
    id: "Classics",
    name: "Classics",
    emoji: "🎬",
    description: "Golden age legends & timeless tales",
    color: "from-amber-500/20 to-yellow-500/20",
    borderColor: "border-amber-500/30",
  },
];

const ClubModal = ({ isOpen, onClose, onSelect }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="glass border-gold/20 max-w-sm" data-testid="club-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-gold text-center">
            Join a Club!
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <p className="text-text-secondary text-sm font-body text-center">
            Congratulations on your first win! Choose your Bollywood tribe:
          </p>

          <div className="space-y-3">
            {CLUBS.map((club, index) => (
              <motion.button
                key={club.id}
                onClick={() => onSelect(club.id)}
                className={`
                  w-full p-4 rounded-lg
                  bg-gradient-to-r ${club.color}
                  border ${club.borderColor}
                  text-left
                  hover:scale-[1.02] transition-transform
                `}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                whileTap={{ scale: 0.98 }}
                data-testid={`club-${club.id.toLowerCase().replace(" ", "-")}`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-3xl">{club.emoji}</span>
                  <div>
                    <p className="text-text-primary font-body font-semibold">
                      {club.name}
                    </p>
                    <p className="text-text-muted text-xs font-body">
                      {club.description}
                    </p>
                  </div>
                </div>
              </motion.button>
            ))}
          </div>

          <p className="text-text-muted text-xs text-center font-body pt-2">
            You can change your club in Settings later
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ClubModal;
